import Image from "next/image";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import styles from "./styles";
import ReactPlayer from "react-player";
import { QRCodeCanvas } from "qrcode.react";

export const ActionsList = ({ video, title }) => {
  const [openVideo, setOpenVideo] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [openMailInput, setOpenMailInput] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    if (openVideo || showQRCode || openMailInput) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openVideo, showQRCode, openMailInput]);

  const actions = [
    {
      icon: "/play.png",
      title: "Watch Video",
    },
    {
      icon: "/Subtract.png",
      title: "Send to Email",
    },
    {
      icon: "/Subtract1.png",
      title: "Send to Phone",
    },
  ];

  const handleActionType = (action) => {
    switch (action.title) {
      case "Watch Video":
        setOpenVideo(true);
        break;
      case "Send to Email":
        setOpenMailInput(true);
        break;
      case "Send to Phone":
        setShowQRCode(true);
        break;
      default:
        console.log("Unknown action");
    }
  };

  const sendEmail = () => {
    const currentPageUrl = window.location.href;
    const mailtoLink = `mailto:${email}?subject=${title}&body=${encodeURIComponent(
      currentPageUrl
    )}`;
    window.location.href = mailtoLink;
    setEmailSent(true);
  };

  const handleClose = () => {
    setOpenVideo(false);
    setShowQRCode(false);
    setOpenMailInput(false);
    setEmail("");
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = () => {
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("Invalid email format");
      return;
    }
    sendEmail();
    setEmailError("");
    setEmailSent(true);
  };

  const handleInputChange = (event) => {
    setEmail(event.target.value);
    setEmailError("");
  };

  const getVideoUrl = (video) => {
    const videoId = video.split("=")[1];

    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <>
      <div className="action-wrapper">
        {actions.map((action) => (
          <div
            className="action"
            key={action.title}
            onClick={() => handleActionType(action)}
          >
            <img draggable="false" src={`/icons/${action.icon}`} alt="icon" />
            <span>{action.title}</span>
          </div>
        ))}
      </div>
      <ReactModal
        isOpen={openVideo}
        onRequestClose={handleClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll={true}
        style={{
          overlay: {
            background: "rgba(255, 255, 255, 0.25)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: -100,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            background: "#242424",
            margin: "5px",
          },
        }}
      >
        <div className="video-wrapper">
          {video ? (
            <ReactPlayer
              className="react-player"
              url={video}
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <div className="no-video-banner">
              <span>Coming soon! We are currently working on a video.</span>
            </div>
          )}
        </div>
      </ReactModal>
      <ReactModal
        isOpen={showQRCode}
        onRequestClose={handleClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll={true}
        style={{
          overlay: {
            background: "rgba(255, 255, 255, 0.25)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: -100,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            padding: "5px",
            background: "white",
            margin: "5px",
          },
        }}
      >
        <div>
          <QRCodeCanvas
            value={typeof window !== "undefined" && window.location.href}
            size={200}
          />
        </div>
      </ReactModal>
      <ReactModal
        isOpen={openMailInput}
        onRequestClose={handleClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll={true}
        style={{
          overlay: {
            background: "rgba(255, 255, 255, 0.25)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: -100,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            padding: "5px",
            background: "#242424",
            margin: "5px",
          },
        }}
      >
        <div className="input-wrapper">
          <h1 className="input-title">Write email: </h1>
          {emailError && (
            <p
              style={{
                color: "#950810",
                fontSize: "18px",
                fontFamily: "Roboto-Medium",
              }}
            >
              {emailError}
            </p>
          )}
          <input
            type="email"
            className="input-mail"
            placeholder="Email"
            value={email}
            onChange={(e) => handleInputChange(e)}
          />
          <span className="input-submit" onClick={handleSubmit}>
            Send to Email
          </span>
          {emailSent && <p>Email sent successfully!</p>}
        </div>
      </ReactModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default ActionsList;
